<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-emv-taps', params: {id: accountId}}">
              {{ $t('emvTap.accountDetailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ resourceId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('emvTap.accountDetailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="entry">
              <emv-tap-details :details="entry"/>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import EmvTapDetails from 'src/components/EmvTap/EmvTapDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountEmvTap",
  components: {
    EmvTapDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    resourceId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountEmvTap']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountEmvTap({accountID: this.accountId, resourceId: this.resourceId});
  },
  computed: {
    ...mapState({
      // darkTheme: state => state.app.darkMode,
      loading: state => state.account_emv_tap.loading,
      entry: state => state.account_emv_tap.data,
    }),
  },
}
</script>

